// vconsole 根据配置文件动态控制
import Vconsole from 'vconsole'

let vConsole = null

// 初始化 vconsole
async function initVConsole() {
  try {
    const response = await fetch(process.env.BASE_URL + 'config.json')
    const config = await response.json()
    if (config.vconsole_enabled === true) {
      vConsole = new Vconsole()
    }
  } catch (error) {
    console.log('vconsole config load failed:', error)
  }
}

// 立即执行初始化
initVConsole()

export default vConsole
